export function extractFeelId(input) {
  if (!input || typeof input !== 'string') {
    return null;
  }

  const trimmedInput = input.trim();

  try {
    const url = new URL(trimmedInput);
    const pathParts = url.pathname.split('/').filter(Boolean);
    
    // Pattern: any domain with /feel/ID or /feels/ID
    if ((pathParts[0] === 'feel' || pathParts[0] === 'feels') && pathParts[1]) {
      return pathParts[1];
    }
    
    // Pattern: any domain with /mm/ID
    if (pathParts[0] === 'mm' && pathParts[1]) {
      return pathParts[1];
    }
  } catch (error) {
    // Not a valid URL, continue to check if it's a direct ID
  }

  // Pattern: Direct feel ID (alphanumeric string, exactly 32 chars)
  const directIdMatch = trimmedInput.match(/^([A-Za-z0-9]{32})$/);
  if (directIdMatch) {
    return directIdMatch[1];
  }

  return null;
}

export function isFeelId(input) {
  return extractFeelId(input) !== null;
}